/**
 * Stytch-based profile mutations for user management
 */

import { useStytchB2BClient } from '@stytch/react/b2b'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

interface UpdateStytchNameData {
	name: string
}

interface UpdateStytchPhoneData {
	mfa_phone_number: string
}

// Update user name via Stytch
export function useUpdateStytchNameMutation() {
	const stytchClient = useStytchB2BClient()

	return useMutation({
		mutationFn: async (data: UpdateStytchNameData): Promise<void> => {
			await stytchClient.self.update({
				name: data.name.trim() || undefined,
			})
		},
		onError: (error) => {
			console.error('Failed to update name:', error)
			toast.error('Failed to update name')
		},
	})
}

// Update user phone number via Stytch
export function useUpdateStytchPhoneMutation() {
	const stytchClient = useStytchB2BClient()

	return useMutation({
		mutationFn: async (data: UpdateStytchPhoneData): Promise<void> => {
			await stytchClient.self.update({
				mfa_phone_number: data.mfa_phone_number,
			})
		},
		onError: (error) => {
			console.error('Failed to update phone number:', error)
			toast.error('Failed to update phone number')
		},
	})
}

// Delete user phone number via Stytch
export function useDeleteStytchPhoneMutation() {
	const stytchClient = useStytchB2BClient()

	return useMutation<void, Error, void>({
		mutationFn: async (): Promise<void> => {
			await stytchClient.self.deleteMFAPhoneNumber()
		},
		onError: (error) => {
			console.error('Failed to delete phone number:', error)
			toast.error('Failed to delete phone number')
		},
	})
}
